export const RESTAURANT = {
  name: "Thai Noodle & Rice",
  location: "Chinatown MCR",
  logo: "https://customer-assets.emergentagent.com/job_authentic-thai-taste/artifacts/30eycw18_IMG_3238.jpeg",
  phone: "01612362395",
  phoneHref: "tel:+441612362395",
  email: "thainoodleandrice@gmail.com",
  address: {
    line1: "48 George Street",
    line2: "Manchester",
    postcode: "M1 4HF",
    country: "United Kingdom",
  },
  tagline_th: "รสชาติคนไทย 100%",
  tagline_en: "Expert in Thai style noodle",
  mapsEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2374.453982424076!2d-2.242781!3d53.4777599!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487bb1bf6786bd61%3A0x8670b86a87e50db2!2s48%20George%20St%2C%20Manchester%20M1%204HF%2C%20UK!5e0!3m2!1sen!2sus!4v1714571930000!5m2!1sen!2sus",
};

export const HOURS = [
  { day: "Monday", time: "Closed", closed: true },
  { day: "Tuesday – Thursday", time: "12:00 – 22:00" },
  { day: "Friday – Saturday", time: "12:00 – 23:00" },
  { day: "Sunday", time: "12:00 – 22:00" },
];

export const IMAGES = {
  // Restaurant-real photography
  hero: "https://customer-assets.emergentagent.com/job_authentic-thai-taste/artifacts/5elti7re_IMG_3247.jpeg",
  interior: "https://customer-assets.emergentagent.com/job_authentic-thai-taste/artifacts/ihdfdu3j_IMG_3246.jpeg",
  interiorEvening: "https://customer-assets.emergentagent.com/job_authentic-thai-taste/artifacts/ihdfdu3j_IMG_3246.jpeg",
  interiorBar: "https://customer-assets.emergentagent.com/job_authentic-thai-taste/artifacts/rdrqtwdp_IMG_3248.jpeg",
  interiorDay: "https://customer-assets.emergentagent.com/job_authentic-thai-taste/artifacts/5elti7re_IMG_3247.jpeg",
  interiorRed: "https://customer-assets.emergentagent.com/job_authentic-thai-taste/artifacts/7wsdbqsc_IMG_3250.jpeg",
  storefront: "https://customer-assets.emergentagent.com/job_authentic-thai-taste/artifacts/z3uzj6y7_IMG_3249.jpeg",
  // Dishes
  padThai:
    "https://images.unsplash.com/photo-1718964313403-2db158f67844?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxwYWQlMjB0aGFpJTIwbm9vZGxlc3xlbnwwfHx8fDE3NzcwMzIxNjJ8MA&ixlib=rb-4.1.0&q=85",
  tomYum: "https://images.pexels.com/photos/10398942/pexels-photo-10398942.jpeg",
  squid: "https://images.pexels.com/photos/16533150/pexels-photo-16533150.jpeg",
  khaoKhaMoo:
    "https://images.unsplash.com/photo-1579619002916-88cd4c81a70c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxwb3JrJTIwcmljZSUyMGJvd2x8ZW58MHx8fHwxNzc3MDMyMTY4fDA&ixlib=rb-4.1.0&q=85",
  boatNoodle:
    "https://images.pexels.com/photos/2664216/pexels-photo-2664216.jpeg?auto=compress&cs=tinysrgb&w=1200",
  kraPao:
    "https://images.unsplash.com/photo-1552611052-33e04de081de?w=1200&q=80",
};

export const MENU = [
  {
    id: "pad-thai",
    name: "Pad Thai Goong",
    th: "ผัดไทยกุ้งสด",
    desc: "Wok-tossed rice noodles, prawns, tamarind, peanuts & fresh lime.",
    price: "£12.99",
    tag: "Signature",
    image: IMAGES.padThai,
  },
  {
    id: "tom-yum",
    name: "Tom Yum Goong",
    th: "ต้มยำกุ้ง",
    desc: "Hot & sour soup with lemongrass, galangal, kaffir lime and prawns.",
    price: "£13.50",
    tag: "Spicy",
    image: IMAGES.tomYum,
  },
  {
    id: "khao-kha-moo",
    name: "Khao Kha Moo",
    th: "ข้าวขาหมู",
    desc: "Slow-braised pork leg over jasmine rice, pickled mustard greens.",
    price: "£13.99",
    tag: "Street Classic",
    image: IMAGES.khaoKhaMoo,
  },
  {
    id: "salt-pepper-squid",
    name: "Salt & Pepper Squid",
    th: "ปลาหมึกทอดพริกเกลือ",
    desc: "Crispy fried squid tossed with chilli, garlic and cracked pepper.",
    price: "£11.50",
    tag: "Crowd Favourite",
    image: IMAGES.squid,
  },
  {
    id: "boat-noodle",
    name: "Boat Noodle Beef",
    th: "ก๋วยเตี๋ยวเรือเนื้อ",
    desc: "Rich, dark broth with tender beef, morning glory & basil.",
    price: "£12.99",
    tag: "Must Try",
    image: IMAGES.boatNoodle,
  },
  {
    id: "pad-kra-pao",
    name: "Pad Kra Pao Gai",
    th: "ผัดกะเพราไก่ไข่ดาว",
    desc: "Minced chicken stir-fried with Thai holy basil, crispy fried egg.",
    price: "£12.50",
    tag: "Chef's Pick",
    image: IMAGES.kraPao,
  },
];

export const GALLERY = [
  {
    src: IMAGES.interiorDay,
    alt: "Inside the restaurant during lunch",
    caption: "Lunch service, George Street",
    span: "md:col-span-6 md:row-span-2",
  },
  {
    src: IMAGES.storefront,
    alt: "Thai Noodle & Rice storefront on George Street",
    caption: "Find us in Chinatown",
    span: "md:col-span-3",
  },
  {
    src: IMAGES.interiorEvening,
    alt: "Evening ambience with hanging lamps and plants",
    caption: "Evenings, candlelit",
    span: "md:col-span-3",
  },
  {
    src: IMAGES.padThai,
    alt: "Pad Thai Goong",
    caption: "Pad Thai Goong",
    span: "md:col-span-3",
  },
  {
    src: IMAGES.interiorBar,
    alt: "The bar",
    caption: "The bar · late-night",
    span: "md:col-span-3",
  },
  {
    src: IMAGES.tomYum,
    alt: "Tom Yum Goong",
    caption: "Tom Yum Goong",
    span: "md:col-span-4",
  },
  {
    src: IMAGES.interiorRed,
    alt: "Red chairs and wooden floor",
    caption: "Warm, wood-floored dining",
    span: "md:col-span-4",
  },
  {
    src: IMAGES.khaoKhaMoo,
    alt: "Khao Kha Moo",
    caption: "Khao Kha Moo",
    span: "md:col-span-4",
  },
];

export const REVIEWS = [
  {
    name: "Elton Hiew",
    meta: "Local Guide · 1,403 reviews",
    when: "4 months ago",
    text: "Authentic Thai cuisine right in Chinatown. The Pad Thai was on the sweeter side—likely adjusted to suit local tastes—but it was still quite enjoyable. Definitely worth the money spent!",
    rating: 5,
  },
  {
    name: "Eric Lim",
    meta: "Local Guide · 13 reviews",
    when: "2 months ago",
    text: "A cosy restaurant up the stairs from street level. Simple fuss-free menu with authentic classic Thai cuisine. Had Khao Kha Moo, salt & pepper squid and the mandatory Thai iced milk tea — everything tasted amazing!",
    rating: 5,
  },
  {
    name: "Kateryna Sokolovska",
    meta: "Local Guide · 97 reviews",
    when: "7 months ago",
    text: "We really wanted something exotic and we didn't miss out by visiting this restaurant. All the ingredients are fresh — it's obvious they cook with love and effort. We liked all the dishes.",
    rating: 5,
  },
  {
    name: "Yến Hải",
    meta: "4 reviews",
    when: "8 months ago",
    text: "The food here is super delicious, with a cozy and warm vibe. The staff are really lovely and friendly. My partner and I ordered Pad Thai and Tom Yum — we both enjoyed them a lot.",
    rating: 5,
  },
  {
    name: "Alina Marcut",
    meta: "Local Guide · 189 reviews",
    when: "4 months ago",
    text: "Very good service but the food has been even better! Really tasty — my husband said his beef curry is the best he's ever had, and my prawn Pad Thai was wonderful.",
    rating: 5,
  },
];
